import React, { useState } from 'react'
import { Accordion, Collapse, Button, Box, withTheme } from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'
import PropTypes from 'prop-types'
import { ClearFilters } from './'
import { RefinementList, PriceRange, Toggle } from './refinements'
import { PlusLogo } from '../../core/icons'

/**
 * Main sidebar content. This should contain any and all filters for search
 *
 * @param {object} theme - The react theme used for getting the primary color
 *
 * @returns {function} React Component
 */
const SidebarContent = ({ theme }) => {
  const plusThemeColor =
    (theme && theme.palette && theme.palette.plus && theme.palette.plus.main) || 'rgb(247, 169, 43)'

  return (
    <Accordion allowMultipleOpen allowAllCollapsed isUncontrolled>
      <Toggle attribute="subscribable.plus" label="Bookshelf PLUS" value isOpenByDefault>
        <PlusLogo style={{ width: '3.5rem', color: plusThemeColor }} />
      </Toggle>
      <RefinementList attribute="producers.name" label="Authors & Artists" isOpenByDefault />
      <RefinementList attribute="variants.department" label="Department" />
      <RefinementList attribute="facetable_taxons.name" label="Category" />
      <RefinementList attribute="variants.option_values.name" label="Format" />
      <PriceRange attribute="variants.msrp" />
      <Toggle attribute="on_sale" label="Promotions" value>
        <span className="has-text-sale">On Sale</span>
      </Toggle>
    </Accordion>
  )
}

SidebarContent.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      plus: PropTypes.shape({
        light: PropTypes.string,
        main: PropTypes.string,
        dark: PropTypes.string,
      }),
    }),
  }),
}

const SidebarContentWithTheme = withTheme(SidebarContent)

/**
 * Holds content for the sidebar
 *
 * @returns {function} React component
 */
export const SidebarContainer = () => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  // For when the content reaches its medium breakpoint
  const isMediumOrSmaller = useMediaQuery({ maxWidth: 1015 })

  return (
    <div>
      {isMediumOrSmaller ? (
        <React.Fragment>
          <Box isFullWidth alignItems="center" justifyContent="space-between">
            <Button onClick={() => setIsCollapsed(!isCollapsed)}>
              {isCollapsed ? 'Show' : 'Hide'} Filters
            </Button>
            <ClearFilters />
          </Box>
          <Collapse isCollapsed={isCollapsed}>
            <SidebarContentWithTheme />
          </Collapse>
        </React.Fragment>
      ) : (
        <SidebarContentWithTheme />
      )}
    </div>
  )
}
